export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/object.aa3bc6f.svg";